<template>
  <Dialog v-model="show" clase="buscador_autocomplete_movil">
    <template v-slot:content>
      <v-autocomplete
          id="appbar_movil_autocomplete_cliente"
          ref="autocomplete"
          solo
          hide-details
          prepend-inner-icon="mdi-account-search"
          :label='$t("Buscar cliente")'
          v-model="cliente_autocomplete"
          :items="cliente_autocomplete_entries"
          :search-input.sync="search"
          @change="cliente_autocomplete_change"
          hide-no-data
          no-filter
      >
        <template v-slot:item="data">
          <template>
            <v-list-item-avatar>
              <v-img :src="data.item.foto_url_absolute_path" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ data.item.text }}<span v-if="data.item.code"> - {{ data.item.code }}</span></v-list-item-title>
              <v-list-item-subtitle>
                <span v-if="show_email_cliente">{{ data.item.email }}</span>
                <span v-if="data.item.email && data.item.movil && show_email_cliente && show_movil_cliente"> - </span>
                <span v-if="show_movil_cliente" >{{ data.item.movil }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </template>

      </v-autocomplete>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: "DialogBuscadorAppBarMovil",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    show_email_cliente: {
      type: Boolean,
      default: false
    },
    show_movil_cliente: {
      type: Boolean,
      default: false
    },
  },
  async mounted() {

    // Debouncer autocomplete cliente
    // Al dejar de escribir, inicializamos el contador
    // Buscamos el input en el DOM
    const input = document.getElementById('appbar_movil_autocomplete_cliente')

    input.addEventListener('keyup', () => {
      clearTimeout(this.autocomplete_cliente_contador);
      this.autocomplete_cliente_contador = setTimeout(() => {
        // alert(this.autocomplete_cliente_timeout)
        this.get_clientes_autocomplete();
      }, this.autocomplete_cliente_timeout);
    });
    input.addEventListener('keydown', () => {
      clearTimeout(this.autocomplete_cliente_contador);
    });
    input.focus()
  },
  data() {
    return {
      cliente_autocomplete: null,
      cliente_autocomplete_entries: [],
      cliente_autocomplete_q: '',
      // Debounce autocomplete cliente
      autocomplete_cliente_contador: null,
      autocomplete_cliente_timeout: 500,
    }
  },
  methods: {
    reset_autocomplete() {
      this.cliente_autocomplete = null
      this.cliente_autocomplete_q = ''
      this.cliente_autocomplete_entries = []
      this.$refs.autocomplete.internalValue = 0
    },

    async get_clientes_autocomplete() {
      if (this.cliente_autocomplete_q.length < 3) return
      const resp = await this.$store.dispatch('cliente/get_clientes_autocomplete', this.cliente_autocomplete_q)
      this.cliente_autocomplete_entries = resp.results
    },

    async cliente_autocomplete_change() {
      if (!this.cliente_autocomplete) return;
      const id_cliente = this.cliente_autocomplete

      this.reset_autocomplete()
      const reload = this.$route.name === 'ficha_cliente'

      this.show_buscar_cliente=false
      await this.$router.push({name: 'ficha_cliente', params: {id: id_cliente}})
      if (reload) {
        this.$router.go(0)
      }
    },
  },
  computed: {
    search: {
      get() {
        return this.cliente_autocomplete_q
      },

      set(searchInput) {
        if (!searchInput) return;
        if (this.cliente_autocomplete_q !== searchInput) {
          this.cliente_autocomplete_q = searchInput
          // this.get_clientes_autocomplete()
        }
      }
    },

    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
}
</script>

<style scoped>

</style>